import { render, staticRenderFns } from "./CircuitoPago.vue?vue&type=template&id=5fc34fbb"
import script from "./CircuitoPago.vue?vue&type=script&lang=js"
export * from "./CircuitoPago.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports